import { Fragment } from 'react'
import { kuiperClassNames } from '@opallabs/kuiper'
import { Module } from '@opallabs/periodic/src/Content/helpers/types'
import { styles } from './styles'

export interface Props {
  index: number
  modules: Module[]
}

export const CarouselIndexWheel: React.FC<Props> = ({ index, modules }) => (
  <Fragment>
    <div css={styles.indexIndicatorContainer}>
      {modules.length < 6 &&
        modules.map((m, i) => (
          <div
            className={kuiperClassNames(
              `${i === index ? 'active' : 'inactive'}-dot`
            )}
            css={styles.indexIndicatorStyles(i === index)}
            key={`carousel-section-${i}`}
          />
        ))}
      {modules.length >= 6 && (
        <Fragment>
          {index > 2 && (
            <Fragment>
              <div
                className={kuiperClassNames(`inactive-dot`)}
                css={styles.indexIndicatorStylesSmall}
              />
              <div
                className={kuiperClassNames(`inactive-dot`)}
                css={styles.indexIndicatorStylesMedium}
              />
            </Fragment>
          )}
          {index === modules.length - 3 || index === 0 ? (
            <div
              className={kuiperClassNames('active-dot')}
              css={styles.indexIndicatorStyles(true)}
            />
          ) : (
            <div
              className={kuiperClassNames('inactive-dot')}
              css={styles.indexIndicatorStyles(false)}
            />
          )}
          {index === modules.length - 2 ||
          index === 1 ||
          (index > 2 && index <= modules.length - 4) ? (
            <div
              className={kuiperClassNames('active-dot')}
              css={styles.indexIndicatorStyles(true)}
            />
          ) : (
            <div
              className={kuiperClassNames('inactive-dot')}
              css={styles.indexIndicatorStyles(false)}
            />
          )}
          {index === modules.length - 1 || index === 2 ? (
            <div
              className={kuiperClassNames('active-dot')}
              css={styles.indexIndicatorStyles(true)}
            />
          ) : (
            <div
              className={kuiperClassNames('inactive-dot')}
              css={styles.indexIndicatorStyles(false)}
            />
          )}
          {index <= modules.length - 4 && (
            <Fragment>
              <div
                className={kuiperClassNames('inactive-dot')}
                css={styles.indexIndicatorStylesMedium}
              />
              <div
                className={kuiperClassNames('inactive-dot')}
                css={styles.indexIndicatorStylesSmall}
              />
            </Fragment>
          )}
        </Fragment>
      )}
    </div>
  </Fragment>
)
